<template>
  <div>
    <add-edit-campaign-dialog
      @disableDialog="disableDialog"
      @resetFrm="resetFrm"
      @switchTitleStatusDialog="switchTitleStatusDialog"
      @addCampaignMarketing="addCampaignMarketing"
      @editCampaignMarketing="editCampaignMarketing"
      :isToggleDialogCampaign="dialogAddCampaign"
      :baseForm="forms"
      :editIndex="editIndex"
      :storeList="storeList"
      :isLoading="isLoading"
    />
    <show-store-dialog
      @disableShowStoreDialog="disableShowStoreDialog"
      :showStoreDialog="showStoreDialog"
      :storeProps="storeProps"
      :storeList="storeList"
    ></show-store-dialog>
    <v-layout row warp text-xs-right>
      <v-flex xs12>
        <v-btn color="yellow" @click="addCampaign" large>
          <v-icon color="black">add_circle_outline</v-icon>เพิ่มรายการ
        </v-btn>
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex xs12>
        <v-toolbar dense flat>
          <v-text-field
            v-model="search"
            prepend-icon="search"
            label="Search"
            single-line
            hide-details
            style="padding:0;"
          ></v-text-field>
        </v-toolbar>
      </v-flex>
    </v-layout>
    <v-data-table
      :search="search"
      :loading="isTableLoading"
      :headers="headers"
      :items="campaignList"
      :pagination.sync="pagination"
    >
      <template v-slot:items="props">
        <td class="text-xs-left">{{ campaignList.indexOf(props.item) + 1 }}</td>
        <td class="text-xs-left">{{ props.item.dm_name_th }}</td>
        <td class="text-xs-left">{{ props.item.dm_name_en }}</td>
        <td class="text-xs-left">{{ props.item.dm_name_cn }}</td>
        <td class="text-xs-center">{{ props.item.dm_start }}</td>
        <td class="text-xs-center">{{ props.item.dm_end }}</td>
        <td class="text-xs-center">{{ props.item.dm_price }}</td>
        <td class="text-xs-center">{{ props.item.dm_minimum }}</td>
        <td class="text-xs-center">
          <v-btn @click="showStoreDetail(props.item.dm_store)" icon>
            <v-icon color="black" small>remove_red_eye</v-icon>
          </v-btn>
        </td>
        <td class="text-xs-center">{{ props.item.dm_time_start }}</td>
        <td class="text-xs-center">{{ props.item.dm_time_end }}</td>
        <td class="text-xs-center">
          <v-switch
            @change="onStatusItemChange(props.item)"
            v-model="props.item.dm_status"
            color="green"
          ></v-switch>
        </td>
        <td class="text-xs-center">
          <v-btn @click="editCampaign(props.item)" icon>
            <v-icon color="black" small>edit</v-icon>
          </v-btn>
        </td>
        <td class="text-xs-center">
          <v-btn @click="deleteCampaign(props.item)" icon>
            <v-icon color="black" small>delete</v-icon>
          </v-btn>
        </td>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import Swal from "sweetalert2";
import AddEditCampaignDialog from "@/components/back-office/CampaignDistance/AddEditCampaignDialog.vue";
import ShowStoreDialog from "@/components/back-office/CampaignDistance/ShowStoreDialog.vue";
import { mapState } from "vuex";
import moment from "moment";
export default {
  async created() {
    this.getStoreList();
    this.getCampaignList();
  },
  components: {
    "add-edit-campaign-dialog": AddEditCampaignDialog,
    "show-store-dialog": ShowStoreDialog,
  },
  computed: {
    ...mapState({
      campaignList: (state) => state.campaigns.campaignMarketingList,
      storeList: (state) => state.fetchStoreBack.store_list,
    }),
  },
  methods: {
    alertDialog(msg, status) {
      Swal.fire({
        position: "center",
        icon: status,
        title: msg,
        showConfirmButton: false,
        timer: 3000,
      });
    },
    moment,
    disableShowStoreDialog() {
      this.showStoreDialog = !this.showStoreDialog;
    },
    showStoreDetail(item) {
      this.storeProps = item;
      this.showStoreDialog = true;
    },
    async onStatusItemChange(item) {
      let rs = await this.$store.dispatch(
        "campaigns/changStatusCampaignMarketing",
        item
      );
      if (rs == false) {
        item.dm_status = !item.dm_status;
      }
    },
    switchTitleStatusDialog() {
      this.editIndex = !this.editIndex;
    },
    addCampaign() {
      this.dialogAddCampaign = !this.dialogAddCampaign;
    },
    disableDialog() {
      //รับค่าจาก event emit addcampaign
      this.dialogAddCampaign = false;
    },
    editCampaign(item) {
      this.dialogAddCampaign = true;
      let strStart = item.dm_time_start;
      let strEnd = item.dm_time_end;
      let datestart = moment(strStart).format("YYYY-MM-DD");
      let timestartHH = moment(strStart).format("HH");
      let timestartMM = moment(strStart).format("MM");
      let dateend = moment(strEnd).format("YYYY-MM-DD");
      let timeendHH = moment(strEnd).format("HH");
      let timeendMM = moment(strEnd).format("MM");
      this.forms = {
        dm_id: item.dm_id,
        dm_name_th: item.dm_name_th,
        dm_name_en: item.dm_name_en,
        dm_name_cn: item.dm_name_cn,
        dm_start: item.dm_start,
        dm_end: item.dm_end,
        dm_time_start: "",
        dm_time_end: "",
        dm_price: item.dm_price,
        dm_minimum: item.dm_minimum,
        datestart,
        timestart: {
          HH: timestartHH,
          mm: timestartMM,
        },
        dateend,
        timeend: {
          HH: timeendHH,
          mm: timeendMM,
        },
        dm_status: item.dm_status,
        dm_store: item.dm_store,
      };
      JSON.parse(JSON.stringify(item));
      this.editIndex = 1;
    },
    async deleteCampaign(item) {
      let check = confirm("Do you want to delete this campaign ?");
      if (check === true) {
        let rs = await this.$store.dispatch(
          "campaigns/deleteCampaignMarketing",
          item
        );
        if (rs == true) {
          this.alertDialog("ลบข้อมูลเรียบร้อยแล้ว", "success");
        } else {
          this.alertDialog("เกิดข้อผิดพลาด ! โปรดลองอีกครั้ง", "error");
        }
      }
    },
    resetFrm() {
      this.forms = {
        dm_name_th: "",
        dm_name_en: "",
        dm_name_cn: "",
        dm_start: "",
        dm_end: "",
        dm_time_start: "",
        dm_time_end: "",
        dm_price: "",
        dm_minimum: "",
        dm_status: true,
        dm_store: null,
        timestart: {
          HH: "",
          mm: "",
        },
        timeend: {
          HH: "",
          mm: "",
        },
        datestart: "",
        dateend: "",
      };
    },
    async getStoreList() {
      this.isLoading = true;
      await this.$store.dispatch("fetchStoreBack/getStoreList");
      this.isLoading = false;
    },
    async getCampaignList() {
      await this.$store.dispatch("campaigns/getCampaignMarketing");
      this.isTableLoading = "null";
    },
    async addCampaignMarketing(form) {
      let rs = await this.$store.dispatch(
        "campaigns/addCampaignMarketing",
        form
      );
      if (rs.msg == true) {
        this.alertDialog("แก้ไขข้อมูลเรียบร้อยแล้ว", "success");
      } else {
        this.alertDialog("เกิดข้อผิดพลาด ! โปรดลองอีกครั้ง", "error");
      }
    },
    async editCampaignMarketing(item) {
      let rs = await this.$store.dispatch(
        "campaigns/editCampaignMarketing",
        item
      );
      if (rs.msg == true) {
        this.alertDialog("แก้ไขข้อมูลเรียบร้อยแล้ว", "success");
      } else {
        this.alertDialog("เกิดข้อผิดพลาด ! โปรดลองอีกครั้ง", "error");
      }
    },
  },
  data() {
    return {
      forms: {
        dm_name_th: "",
        dm_name_en: "",
        dm_name_cn: "",
        dm_start: "",
        dm_end: "",
        dm_time_start: "",
        dm_time_end: "",
        dm_price: "",
        dm_minimum: "",
        dm_status: true,
        dm_store: null,
        timestart: {
          HH: "",
          mm: "",
        },
        timeend: {
          HH: "",
          mm: "",
        },
        datestart: "",
        dateend: "",
      },
      search: "",
      isLoading: true,
      showStoreDialog: false,
      isTableLoading: "black",
      campaignDelete: {},
      editIndex: -1,
      storeProps: [],
      dialogAddCampaign: false,
      pagination: {
        rowsPerPage: 10,
      },
      headers: [
        {
          text: "No",
          align: "center",
          sortable: false,
          value: "dm_name_th",
        },
        {
          text: "ชื่อแคมเปญ (TH)",
          align: "center",
          sortable: false,
          value: "dm_name_th",
        },
        {
          text: "ชื่อแคมเปญ (ENG)",
          align: "center",
          sortable: false,
          value: "dm_name_en",
        },
        {
          text: "ชื่อแคมเปญ (CN)",
          align: "center",
          sortable: false,
          value: "dm_name_cn",
        },
        {
          text: "ระยะทางเริ่มต้น",
          align: "center",
          sortable: false,
          value: "dm_start",
        },
        {
          text: "ระยะทางสิ้นสุด",
          align: "center",
          sortable: false,
          value: "dm_end",
        },
        {
          text: "ส่วนลด (บาท)",
          align: "center",
          sortable: false,
          value: "dm_price",
        },
        {
          text: "ราคาขั้นต่ำ (บาท)",
          align: "center",
          sortable: false,
          value: "dm_minimum",
        },
        {
          text: "ร้านค้าที่ร่วมแคมเปญ",
          align: "center",
          sortable: false,
          value: "dm_store",
        },
        {
          text: "วัน/เวลา (เริ่มต้น)",
          align: "center",
          sortable: false,
          value: "dm_time_start",
        },
        {
          text: "วัน/เวลา (สิ้นสุด)",
          align: "center",
          sortable: false,
          value: "dm_time_end",
        },
        {
          text: "สถานะ",
          align: "center",
          sortable: false,
          value: "dm_status",
        },
        {
          text: "Edit",
          align: "center",
          sortable: false,
        },
        {
          text: "Delete",
          align: "center",
          sortable: false,
        },
      ],
    };
  },
};
</script>
